import React, { useRef, useState, useEffect } from 'react'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import SliderWrapper from './_SlickSlider'
import CustomImage from '../../customImage/customImage'
import { isEmpty } from 'lodash'
import EditMenu from '../editMenu'
import AddSection from '../addSection'
import useTemplateHook from '../templateHook'

const UnikornsCardCarouselPricing = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
}) => {
  const { LeftArrow, RightArrow, getTemplateImage, customNavigate } = useTemplateHook()
  const { data, id } = componentData
  const sliderRef = useRef(null)
  const [hoverState, setHoverState] = useState('')

  useEffect(() => {
    if (data?.card_data?.length > 0 && sliderRef.current) {
      setTimeout(() => {
        sliderRef.current.slickGoTo(0)
      }, 100)
    }
  }, [data?.card_data])

  function SampleNextArrow(props) {
    const { className, style, onClick, transform } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          background: 'transparent',
          width: '46px',
          height: '46px',
          position: 'absolute',
          top: '50%',
          right: '0px',
          transform: `translateX(-${transform}px) translateY(-50%)`,
          content: `url(${RightArrow})`,
        }}
        onClick={onClick}
      >
        <img src={RightArrow} alt="Next" style={{ width: '100%', height: '100%' }} />
      </div>
    )
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick, transform } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          background: 'transparent',
          width: '46px',
          height: '46px',
          position: 'absolute',
          top: '50%',
          left: '0px',
          transform: `translateX(${transform}px) translateY(-50%)`,
          content: `url(${LeftArrow})`,
          zIndex: '10',
        }}
        onClick={onClick}
      >
        <img src={LeftArrow} alt="Previous" style={{ width: '100%', height: '100%' }} />
      </div>
    )
  }

  const settings = {
    dots: false,
    autoplaySpeed: 2500,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    pauseOnHover: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  }

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }
  return (
    <div
      className={`w-full py-6 px-4 relative  ${isEdit && hoverState && 'component-hover-class'} `}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
      style={{ background: getStyleValue('component_color', 'component_color', '') }}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onEdit={() => handleModal()}
          onCopy={() => onCopy(id)}
        />
      )}
      <div style={{ maxWidth: '1269px', margin: '0 auto' }}>
        <p
          style={{ color: getStyleValue('component_color', 'component_heading_color', '') }}
          className="text-xs md:text-sm lg:text-xl mb-8 font-semibold"
        >
          {data?.title}
        </p>

        <SliderWrapper>
          <Slider {...settings} ref={sliderRef}>
            {data?.card_data?.map((item) => (
              <div key={item.id} className="cursor-pointer px-2">
                <div
                  className="rounded-lg h-[310px] md:h-[335px]  xl:h-[25.5625rem]"
                  style={{
                    backgroundColor: getStyleValue('card_style', 'card_background', ''),
                    border: `4px solid ${getStyleValue('card_style', 'card_background', '')}`,
                  }}
                  onClick={() => handleRedirect(item.link)}
                >
                  {/* Image Container */}
                  <div className="relative">
                    <CustomImage
                      imageUrl={getTemplateImage(item?.image_s3key)}
                      imgAlt={item?.card_heading}
                      imgClass="w-full object-cover rounded-t-lg"
                    />
                  </div>

                  {/* Content */}
                  <div className="xl:px-2 h-1/4 xl:h-[20%] pt-2 pb-1 xl:pb-2 flex flex-col justify-between">
                    <p
                      className="mb-0 text-[10px] sm:text-xs xl:text-sm font-semibold line-clamp-2"
                      style={{
                        color: getStyleValue('card_style', 'card_title_heading', ''),
                      }}
                    >
                      {item.card_heading}
                    </p>
                    <div className="flex items-center gap-1 mt-2 text-[10px] sm:text-[11px] flex-wrap">
                      {item?.pricing_text && (
                        <span
                          className="font-semibold"
                          style={{
                            color: getStyleValue('card_style', 'card_pricing_text', ''),
                          }}
                        >
                          {item?.pricing_text}
                        </span>
                      )}

                      {item?.old_pricing_text && (
                        <span
                          className="line-through"
                          style={{
                            color: getStyleValue('card_style', 'card_old_pricing', ''),
                          }}
                        >
                          {item?.old_pricing_text}
                        </span>
                      )}

                      {item?.discount_text && (
                        <span
                          className="font-semibold"
                          style={{
                            color: getStyleValue('card_style', 'card_old_pricing', ''),
                          }}
                        >
                          {item?.discount_text}
                        </span>
                      )}
                    </div>
                    {/* <p
                        className="text-[10px] sm:text-xs md:text-sm mt-3 font-semibold"
                        style={{
                          color: getStyleValue('card_style', 'card_title_sub_heading', ''),
                        }}
                      >
                        {item.card_sub_heading}
                      </p> */}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </SliderWrapper>
      </div>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

export default UnikornsCardCarouselPricing
